import { render, staticRenderFns } from "./CateringBotPackageCard.vue?vue&type=template&id=3fdc7e61&scoped=true"
import script from "./CateringBotPackageCard.vue?vue&type=script&lang=ts"
export * from "./CateringBotPackageCard.vue?vue&type=script&lang=ts"
import style0 from "./CateringBotPackageCard.vue?vue&type=style&index=0&id=3fdc7e61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdc7e61",
  null
  
)

export default component.exports